(ns practitest.frontend.global-fields-settings.views
      (:require
        [re-frame.core :as re-frame]
        [practitest.frontend.common.mixpanel :as mixpanel]
        [practitest.frontend.common.i18n :refer [get-translation format-translation]]
        [practitest.frontend.common.re-frame :refer [partial-dispatch partial-subscribe partial-dispatch-sync]]
        [practitest.frontend.components.icons :as icons]
        [practitest.frontend.components.navigation :as navigation]
        [practitest.frontend.components2.buttons :as buttons]
        [practitest.frontend.components2.grid :as grid2]
        [practitest.frontend.components2.grid.common :as gc]
        [practitest.frontend.components.selector2 :as selector2]
        [practitest.frontend.components2.grid.row-menu :refer [row-menu]]
        [practitest.frontend.global-fields-settings.subs :as global-fields-subs]
        [practitest.frontend.global-fields-settings.events :as global-fields-events]
        [practitest.frontend.components.grid.localstorage :as grid-storage]
        [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
        [practitest.frontend.routing.backend-routes :as broutes]
        [practitest.frontend.forms3.entity-form.forms :as forms3]
        [practitest.frontend.forms3.entity-form.fields :as fields3]
        [practitest.frontend.components.tooltip :as tooltip]
        [practitest.frontend.components.modal :as modal]
        [practitest.frontend.components.notifications :as notifications]
        [practitest.frontend.components.spinners :as spinners]
        [practitest.frontend.common.dom :as dom]
        [reagent.core :as reagent]
        [clojure.string :as string]
        [practitest.frontend.subs :as subs]
        [practitest.frontend.forms3.global-field-form :as global-field-form]
        [practitest.frontend.global-fields-settings.confirmation-modal :refer [delete-confirmation-modal]]
        [practitest.frontend.global-fields-settings.utils :as global-field-utils]
        [practitest.frontend.global-fields-settings.common :as global-field-common]
        [practitest.frontend.components2.async-status-banner :as async-status-banner]))

(defn- save-button-disabled? [form-data]
  (let [field-values (vals form-data)
        dirty-fields (filter :dirty? field-values)
        fields-with-errors (filter (fn [field] (not (empty? (:errors field)))) field-values)]
    (or (empty? dirty-fields)
        (seq fields-with-errors))))

(defn- save-button-on-click [{:keys [edit? is-enforced?]}]
  (let [form-errors (global-field-form/force-form-validation! {:edit? edit?})]
    (when-not (seq form-errors)
      (if (or is-enforced? edit?)
        (re-frame/dispatch [::global-fields-events/check-field-relationship edit?])
        (re-frame/dispatch [::global-fields-events/save-global-field {:edit? edit?}])))))

(defn- linked-projects-item
  [{:keys [item inner-ref on-hover on-change hover?]}]
  (let [{:keys [id name all?]} item]
    (if all?
      [:div.selector-item.linked-project-item.all-projects
       {:ref inner-ref}
       [:span.project-name name]]
      [:div.selector-item.linked-project-item
       {:class (dom/classes-pairs :hover hover?)
        :ref inner-ref
        :on-mouse-over on-hover
        :on-mouse-move on-hover
        :on-click #(when on-change (on-change item))}
       [:span.project-id (str id)]
       [:span.project-name name]])))

(defn- linked-projects-cell [{:keys [field]} row]
  (let [count-val (get row field)
        field-id (:id row)]
    (if (and count-val (pos? count-val))
      (let [data @(re-frame/subscribe [::global-fields-subs/linked-project-names field-id])
            total @(re-frame/subscribe [::global-fields-subs/total-projects-count])
            projects (:projects data)
            all-projects? (and total (= count-val total))
            items (if all-projects?
                    [{:id :all :name (get-translation "global-fields.all-projects" "All Projects") :all? true}]
                    (or projects []))]
        [selector2/new-select
         {:items items
          :label-fn :name
          :key-fn :id
          :class "linked-projects-selector"
          :filterable? (not all-projects?)
          :on-focus (fn [_]
                      (mixpanel/track "Global_Fields" {"Action" "View_Linked_Projects"})
                      (re-frame/dispatch [::global-fields-events/fetch-linked-project-names field-id]))
          :empty-placeholder (get-translation "global-fields.no-matching-projects" "No matching projects")
          :on-change (fn [_])
          :selector-item-renderer linked-projects-item
          :selected-item-renderer (fn [_] [:span.linked-projects-count (str count-val)])}])
      [:span (str (or count-val 0))])))

(gc/register-field-type!
  :linked_projects
  gc/header-title
  (fn [{:keys [field]} row]
    (str (get row field)))
  linked-projects-cell
  gc/default-search-fn
  (fn [{:keys [field]} direction row-a row-b]
    (let [a (or (get row-a field) 0)
          b (or (get row-b field) 0)]
      (if (= direction :asc)
        (compare a b)
        (compare b a)))))

(gc/register-field-type!
  :global-field-name
  gc/header-title
  (fn [{:keys [field]} row]
    (let [value (get row field)]
      (when (map? value) (:title value))))
  (fn [field-data row]
    (let [value (get row (:field field-data))]
      (when (map? value)
        (let [{:keys [url title]} value]
          [:span [:span.global-field-icon {:role "img" :aria-label (get-translation "global-fields.migration.global-field" "Global Field")} global-field-common/global-field-icon] " " [:a {:href url} title]]))))
  gc/default-search-fn
  gc/default-compare-fn)

(def columns
  [{:autofilter? true
    :default-width 200
    :field :edit-url
    :header (get-translation "global-fields.form-fields.name" "Field name")
    :type :global-field-name}
   {:autofilter? true
    :default-width 200
    :field :type
    :header (get-translation "global-fields.form-fields.format" "Format")
    :type :global_field_type}
   {:sortable? true
    :default-width 200
    :field :linked_projects
    :header (get-translation "generic.label.linked-projects" "Linked Projects")
    :type :linked_projects}
   {:autofilter? true
    :default-width 200
    :field :updated_at
    :header (get-translation "generic.label.last-updated" "Last Updated")
    :type :date-time}])

(defn migration-wizard-form-props []
  (let [migration-wizard-form-id :global-fields-migration-wizard
        set-field-state-fn (partial-dispatch-sync [::forms3/set-field-state migration-wizard-form-id])]
    {:get-field-props (partial-subscribe [::global-fields-subs/migration-wizard-field-props])
     :get-form-state (partial-subscribe [::forms3/form-state migration-wizard-form-id])
     :set-form-state (partial-dispatch [::forms3/set-form-state migration-wizard-form-id])
     :get-field-state (partial-subscribe [::forms3/field-state migration-wizard-form-id])
     :set-field-state (fn [field-name field-value]
                        (set-field-state-fn field-name field-value)
                        ;; Trigger fetch when global field is selected
                        (when (and (= field-name :selected-global-field)
                                   (-> field-value :value))
                          (re-frame/dispatch [::global-fields-events/migration-select-global-field (-> field-value :value)])))}))

(defn- get-row-menu-actions [row migration-locked?]
  (let [linked-count (or (:linked_projects row) 0)
        delete-body  (if (pos? linked-count)
                       (format-translation
                        (get-translation "global-fields.confirm.delete.body.linked"
                                         "Global field will be deleted permanently. It is linked to %{count} projects.")
                        :count linked-count)
                       (get-translation "global-fields.confirm.delete.body"
                                        "Global field will be deleted permanently."))
        base-actions [{:label (get-translation "generic.button.edit" "Edit")
                       :icon icons/mux-pencil
                       :href (get-in row [:edit-url :url])}
                      {:label (get-translation "generic.button.delete" "Delete")
                       :icon icons/mux-trash
                       :on-click (fn []
                                   (mixpanel/track "Grid Actions" {"Action" "Force Delete Global Field"})
                                   (re-frame/dispatch [::global-fields-events/force-delete-field (:id row)]))
                       :confirmation {:title     (get-translation "global-fields.confirm.delete.title" "Delete Global Field?")
                                      :body      delete-body
                                      :yes-label (get-translation "global-fields.confirm.force-delete.button" "Delete and unlink")
                                      :no-label  (get-translation "generic.button.cancel" "Cancel")}}]
        migrate-action {:label (get-translation "generic.button.migrate" "Migrate")
                        :icon icons/mux-replace
                        :disabled? migration-locked?
                        :tooltip (when migration-locked?
                                   (get-translation "global-fields.migration.only-one-at-a-time" "Only one migration at a time"))
                        :on-click (fn []
                                    (mixpanel/track "Grid Actions" {"Action" "Open Migration Wizard"})
                                    (re-frame/dispatch [::global-fields-events/show-migration-wizard (:id row)]))}
        has-linked-children? (:has_linked_children row)
        linked-list-action {:label (get-translation "global-fields.button.pull-children" "Import linked List/s")
                            :icon icons/mux-replace
                            :disabled? (or (not has-linked-children?) migration-locked?)
                            :tooltip (cond
                                       migration-locked?
                                       (get-translation "global-fields.migration.only-one-at-a-time" "Only one migration at a time")
                                       (not has-linked-children?)
                                       (get-translation "global-fields.button.pull-children-no-linked" "No linked fields"))
                            :on-click (fn []
                                        (mixpanel/track "Grid Actions" {"Action" "Open Linked List Wizard"})
                                        (re-frame/dispatch [::global-fields-events/show-linked-list-wizard (:id row) (:label row)]))}
        migratable-types @(re-frame/subscribe [::global-fields-subs/migratable-field-types])
        migratable-type? (contains? migratable-types (keyword (:type row)))]
    (cond-> base-actions
      migratable-type? (conj migrate-action)
      true (conj linked-list-action))))

(def post-columns
  [{:header        ""
    :field         :actions
    :default-width 50
    :width         50
    :type          :custom
    :text-align    :center
    :resizable?    false
    :sortable?     false
    :systemcol?    true
    :class         ["action-menu"]
    :cell-fn       (fn [_ row]
                     (let [{:keys [locked?]} @(re-frame/subscribe [::global-fields-subs/migration-status])]
                       [row-menu row false
                        (get-row-menu-actions row locked?)]))}])

(defn grid-button []
  (let [current-account @(re-frame/subscribe [::subs/current-account])
        {:keys [locked?]} @(re-frame/subscribe [::global-fields-subs/migration-status])
        migration-button (fn [{:keys [disabled?]}]
                           [buttons/button {:class "add-button"
                                            :primary? true
                                            :disabled? disabled?
                                            :icon [icons/mux-replace]
                                            :text (get-translation "generic.button.migration-tool" "Migration Tool")
                                            :on-click (when-not disabled?
                                                        (fn []
                                                          (mixpanel/track "Grid Actions" {"Action" "Open Migration Wizard"})
                                                          (re-frame/dispatch [::global-fields-events/show-migration-wizard])))}])]
    [:div.m-button-group
     (if locked?
         [tooltip/mux-tooltip {:position "top"}
          (get-translation "global-fields.migration.only-one-at-a-time" "Only one migration at a time")
          (fn [props]
            [:div (merge (dissoc props :arrowProps :popper :show)
                         {:style {:display "inline-block" :cursor "default"}})
             [:div {:style {:pointer-events "none"}}
              [migration-button {:disabled? true}]]])]
         [migration-button {:disabled? false}])
     [buttons/button {:class "add-button"
                      :primary? true
                      :icon [icons/mux-add-step]
                      :text "Create New Field"
                      :href (broutes/get-url-view "accounts#global_fields_new" {:account_id (:id current-account)})}]]))

(defn global-fields-grid [grid-state]
  (let [table-id "global-fields-index"
        global-fields @(re-frame/subscribe [:global-fields-settings/get-all-fields])
        menu-collapsed? @(re-frame/subscribe [::navigation/project-level-menu-collapsed?])
        data (mapv (fn [gf]
                     (assoc gf
                            :edit-url {:title (global-field-common/strip-global-field-icon (:label gf))
                                       :url (broutes/get-url-view "accounts#global_fields_edit" {:account_id (:account_id gf)
                                                                                                 :global-field-id (:id gf)})}))
                     global-fields)
        grid-props {:columns columns
                    :post-columns post-columns
                    :resizable? true
                    :table-id table-id
                    :grid-state grid-state
                    :local-state-updating grid-state
                    :full-data? true
                    :expanded? menu-collapsed?
                    :on-expand-click (fn [] (re-frame/dispatch [::navigation/set-project-level-menu-collapsed? (not menu-collapsed?)]))
                    :current-page-load     (reagent/partial grid-storage/load-current-page table-id)
                    :current-page-save     (reagent/partial grid-storage/save-current-page table-id)
                    :per-page-save         (reagent/partial grid-storage/save-per-page table-id)
                    :per-page-load         (reagent/partial grid-storage/load-per-page table-id)
                    :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id)
                    :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id)
                    :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id)
                    :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id)
                    :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
                    :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
                    :data data
                    :grid-toolbar grid-button
                    :empty-table-message [:div.empty-section-grid (get-translation "global-field.grid.no_global_fields" "No global fields defined")]
                    :class "admin-page-table"}]
    [:div.global-fields-grid
     [grid2/grid grid-props]]))

(defn- hide-all-tooltips! []
  (doseq [tooltip (array-seq (.querySelectorAll js/document ".mux-tooltip.show"))]
    (set! (.-visibility (.-style tooltip)) "hidden")))

(defn- delete-global-field-alert-body
  [{:keys [field_name linked_projects linkedlist_children blockers]}]
  [:<>
   [:p (format-translation
        (get-translation "global-fields.error-deleting.body.p1"
                         "Cannot delete the list field '%{field_name}'. This field is currently used by other items in the system.")
        :field_name field_name)]
   [:p (get-translation "global-fields.error-deleting.body.p2"
                        "Please review the following items and remove the usage before continuing")]
   [:div.list-section
    [:span.bold (if linkedlist_children
                  (get-translation "global-fields.error-deleting.body.p3.fields" "Fields")
                  (get-translation "global-fields.error-deleting.body.p3.items" "Items"))
                ":"]
    [:br]
    (if linkedlist_children
      (doall (map (fn [field]
                    (let [formatted-field (format-translation
                                           (get-translation "global-fields.error-deleting.body.p3.message1"
                                                            "Linked List Field '%{field_name}' depends on this field")
                                           :field_name (:name field))]
                      (with-meta
                        [:div.project-link
                         [:a {:href (:url field) :target "_blank"} formatted-field]]
                        {:key (:id field)})))
                  linkedlist_children))
      (doall (for [project linked_projects
                   :let [project-blockers (or (get blockers (keyword (str (:id project))))
                                              (get blockers (str (:id project))))]
                   usage (:usages project-blockers)]
               ^{:key (str (:id project) "-" (:type usage) "-" (or (:item_id usage) (:name usage)))}
               [:div.project-link
                [:a {:href (:url usage) :target "_blank"}
                 (str (:type usage) ": " (:name usage))]])))]])

(defn- delete-global-field-alert []
  (let [show? (re-frame/subscribe [::global-fields-subs/global-fields-show-modal])
        {:keys [title alert-modal? field_name linked_projects linkedlist_children blockers]}
        @(re-frame/subscribe [::global-fields-subs/global-fields-modal-data])]
    (when alert-modal?
      [delete-confirmation-modal
       {:show?        show?
        :show-footer? false
        :title        title
        :body         [delete-global-field-alert-body
                       {:field_name          field_name
                        :linked_projects     linked_projects
                        :linkedlist_children linkedlist_children
                        :blockers            blockers}]
        :on-cancel    (fn [] (re-frame/dispatch [::global-fields-events/global-fields-hide-modal :modal-data]))}])))

(defn- render-migration-field-item
  [field {:keys [selected-project-fields field-id-to-project-name
                 selected-global-field-type selected-global-field-parent-id on-click clickable?]}]
  (let [is-field-integrated? (boolean (:has_integration field))
        is-type-mismatch? (and selected-global-field-type
                             (not= (name selected-global-field-type) (:type field)))
        parent-mismatch? (and (= "linkedlist" (:type field))
                                 selected-global-field-parent-id
                                 (not= selected-global-field-parent-id (:parent_list_id field)))
        already-migrated? (boolean (:already_migrated_to_global field))
        is-selected? (boolean (some #(= (:id %) (:id field)) selected-project-fields))
        other-field-from-same-project-selected? (and (not is-selected?)
                                                     (some #(= (:project_id %) (:project_id field)) selected-project-fields))
        field-disabled? (or is-field-integrated? is-type-mismatch? parent-mismatch?
                          other-field-from-same-project-selected?)
        field-label (:label field)
        disabled-reason (cond
                          other-field-from-same-project-selected?
                          (get-translation "global-fields.migration.other-field-from-same-project-selected-reason"
                                         "Only one field from this project can be migrated. Deselect the currently selected field from this project to select this one.")
                          already-migrated?
                          (get-translation "global-fields.migration.already-migrated-reason"
                                         "This field is already migrated to the selected global field")
                          is-field-integrated?
                          (get-translation "global-fields.migration.field-is-integrated-info"
                                           "This field is mapped for integration and can not be replaced by global one.")
                          is-type-mismatch?
                          (get-translation "global-fields.migration.type-mismatch-info"
                                         (str "Field type (" (:type field) ") does not match the selected global field type. Please select a different global field or field."))
                          parent-mismatch?
                          (get-translation "global-fields.migration.parent-mismatch-info"
                                         "This linked list has a different parent field than the selected global linked list. Only linked lists with the same parent can be migrated.")
                          :else nil)
        project-name (str " (" (or (:project_name field) (get field-id-to-project-name (:id field))) ")")
        ]
    (if field-disabled?
      [:div.field-item {:class "disabled"}
       [:div.field-info
        [:div.field-main-info
         [tooltip/mux-tooltip
          {:position "top"
           :delay {:show 500}}
          field-label
          (fn [props]
            [:div.field-name (dissoc props :onMouseEnter :onMouseLeave)
             field-label])]
         [tooltip/mux-tooltip
          {:position "top"
           :delay {:show 500}}
          project-name
          (fn [props]
            [:div.field-project (dissoc props :onMouseEnter :onMouseLeave)
             (str project-name)])]]
        [:div.field-meta
         [:div.icon-wrapper
          [tooltip/mux-tooltip
           {:position "top"
            :trigger "click"}
           disabled-reason
           (fn [props]
             [:div (dissoc props :onMouseEnter :onMouseLeave)
              [icons/mux-info-circle]])]]]]]
      [:div.field-item
       {:class (when field-disabled? "disabled")}
       [:div.field-info
        [:div.field-main-info
         [tooltip/mux-tooltip
          {:position "top"
           :delay {:show 500}}
          field-label
          (fn [props]
            [:div.field-name (dissoc props :onMouseEnter :onMouseLeave)
             field-label])]
         [tooltip/mux-tooltip
          {:position "top"
           :delay {:show 500}}
          project-name
          (fn [props]
            [:div.field-project (dissoc props :onMouseEnter :onMouseLeave)
             (str project-name)])]]
        [:div.field-meta
         [:div.icon-wrapper
          {:on-click (when (and clickable? (not field-disabled?))
                       on-click)}
          (if is-selected? [icons/mux-circle-less] [icons/mux-circle-plus])]]
        ]])))

(defn- migration-fields-two-panel
  [available-fields selected-fields-data fields-loading? search-query
   field-id-to-project-name selected-global-field-type selected-global-field-parent-id selected-project-fields]
  [fields3/two-panel-selector
   {:available-items available-fields
    :selected-items selected-fields-data
    :item-renderer (fn [field options]
                     [render-migration-field-item field
                      (assoc options
                             :selected-project-fields selected-project-fields
                             :field-id-to-project-name field-id-to-project-name
                             :selected-global-field-type selected-global-field-type
                             :selected-global-field-parent-id selected-global-field-parent-id)])
    :search-value search-query
    :on-search-change (fn [e]
                        (let [value (-> e .-target .-value)]
                          (re-frame/dispatch [::global-fields-events/migration-update-search value])))
    :on-item-click (fn [field]
                     (let [field-project-name (get field-id-to-project-name (:id field))]
                       (re-frame/dispatch [::global-fields-events/migration-toggle-project-field field field-project-name])))
    :loading? fields-loading?
    :left-panel-title (get-translation "global-fields.migration.available-fields" "Available Fields")
    :right-panel-title (get-translation "global-fields.migration.selected-fields" "Selected Fields")
    :empty-state-left (if (and search-query (not (string/blank? search-query)))
                        (get-translation "global-fields.migration.no-search-results" "No fields found matching your search")
                        (get-translation "global-fields.migration.no-available-fields" "No available fields"))
    :empty-state-right (get-translation "global-fields.migration.no-selected-fields"
                                       "Click fields from the left panel to select them")
    :on-scroll (fn [e]
                 (let [element (.-target e)
                       scroll-top (.-scrollTop element)
                       scroll-height (.-scrollHeight element)
                       client-height (.-clientHeight element)
                       ;; Trigger when within 200px of bottom
                       distance-from-bottom (- scroll-height scroll-top client-height)]
                   (when (<= distance-from-bottom 200)
                     (re-frame/dispatch [::global-fields-events/fetch-next-page])))
                 (hide-all-tooltips!))
    :class-prefix "project-fields"}])

(defn- migration-fields-selection-step [wizard-data]
  (let [{:keys [search-query]} wizard-data
        selected-project-fields @(re-frame/subscribe [::global-fields-subs/selected-project-fields])
        selected-global-field @(re-frame/subscribe [::global-fields-subs/selected-global-field])
        project-fields-by-project @(re-frame/subscribe [::global-fields-subs/migration-wizard-project-fields])
        fields-loading? @(re-frame/subscribe [::global-fields-subs/migration-wizard-project-fields-loading?])
        migratable-types @(re-frame/subscribe [::global-fields-subs/migratable-field-types])
        selected-global-field-type (when selected-global-field
                                     (keyword (:field_format selected-global-field)))
        selected-global-field-parent-id (when selected-global-field
                                          (:parent_list_id selected-global-field))
        ;; Create a lookup map from field ID to project name
        field-id-to-project-name (reduce (fn [acc project-data]
                                           (let [project-name (:project_name project-data)
                                                 fields (:fields project-data)]
                                             (reduce (fn [acc* field]
                                                       (assoc acc* (:id field) project-name))
                                                     acc
                                                     fields)))
                                         {}
                                         project-fields-by-project)
        ;; Flatten all fields from all projects
        all-fields (mapcat :fields project-fields-by-project)
        ;; Show all migratable types regardless of selected global field
        ;; We'll disable fields that don't match the type instead of hiding them
        project-fields (filter #(contains? migratable-types (keyword (:type %)))
                              all-fields)
        ;; Partition fields into available and selected
        available-fields (filter (fn [field]
                                  (not (some #(= (:id %) (:id field)) selected-project-fields)))
                                project-fields)
        ;; Selected fields are stored directly as field objects
        selected-fields-data selected-project-fields]
    [:div.migration-step.migration-fields-selection-step
     ;; Global Field Selection Section
     [:div.global-field-form
      [fields3/build-field
       {:field-name :selected-global-field
        :edit-permissions? true}
       (migration-wizard-form-props)]
      ]

     ;; Project Fields Selection Section
     [:div.wizard-section.project-fields-section
      {:class (when-not selected-global-field "disabled")}
      [:h3.section-title (get-translation "global-fields.migration.select-project-fields" "Select Project Level Fields")]
      [:div.project-fields-content
       (when selected-global-field
         [:div.helper-text
          [:span (get-translation
                  "global-fields.migration.select-fields-help"
                  "Select fields to migrate to the selected global field.")]
          [:br]
          [:span (get-translation
            "global-fields.migration.select-fields-help-part-2"
            "Only fields of the same type are available. Choose One field from each project.")]])

       [migration-fields-two-panel available-fields selected-fields-data fields-loading? search-query
        field-id-to-project-name selected-global-field-type selected-global-field-parent-id selected-project-fields]]]]))

;; Create grid-state once to persist across re-renders
(def value-mapping-grid-state (reagent/atom {:module "value-mapping"}))

(defn- value-mapping-grid [all-project-values global-field-values value-mappings keep-union?]
  (let [get-mapping-status (fn [proj-val]
                            (let [mapped (get value-mappings proj-val)]
                              {:mapped? (not (nil? mapped))
                               :value mapped}))
        mapping-columns [{:header (get-translation "global-fields.migration.project-values" "Project Field Values")
                          :field :project-value
                          :default-width 400
                          :sortable? true
                          :autofilter? true
                          :type :text
                          :cell-fn (fn [value row]
                                   [:div.project-value-cell
                                    [:span.value-text value]
                                    (when (:is-auto-matched? row)
                                      [:span.auto-match-badge (get-translation "global-fields.migration.auto" "Auto")])])}
                        {:header (get-translation "global-fields.migration.global-values" "Global Field Values")
                         :field :global-value
                         :default-width 400
                         :type :custom
                         :cell-fn (fn [_ row]
                                    [fields3/build-field
                                     {:field-name (:field-name row)
                                      :edit-permissions? (not keep-union?)}
                                     (migration-wizard-form-props)])}]
        grid-data (vec (map-indexed (fn [idx project-value]
                         (let [mapping-status (get-mapping-status project-value)
                               mapped-value (:value mapping-status)
                               is-mapped? (:mapped? mapping-status)
                               has-exact-match? (some #{project-value} global-field-values)
                               effective-value (or mapped-value
                                                  (when has-exact-match? project-value))
                               is-auto-matched? (and has-exact-match?
                                                    (not is-mapped?)
                                                    (= effective-value project-value))
                               field-name (keyword (str "value-mapping-" idx))]
                           {:project-value project-value
                            :global-value effective-value
                            :field-name field-name
                            :is-auto-matched? is-auto-matched?
                            :show-warning? (and (not is-mapped?) (not has-exact-match?))}))
                       all-project-values))]
    [grid2/grid {:columns mapping-columns
                 :table-id "value-mapping-grid"
                 :grid-state value-mapping-grid-state
                 :local-state-updating value-mapping-grid-state
                 :data grid-data
                 :full-data? true
                 :resizable? false
                 :sort-order-save (reagent/partial grid-session-storage/save-sort-order "value-mapping-grid")
                 :sort-order-load (reagent/partial grid-session-storage/load-sort-order "value-mapping-grid")
                 :autofilters-save (reagent/partial grid-session-storage/save-autofilters "value-mapping-grid")
                 :autofilters-load (reagent/partial grid-session-storage/load-autofilters "value-mapping-grid")
                 :read-only? true
                 :class (dom/classes-pairs :disabled-table keep-union? :value-mapping-grid true)
                 :empty-table-message [:div.empty-state
                                      [:p (get-translation "global-fields.migration.no-values" "No values to map")]]}]))

(defn- migration-value-mapping-step [wizard-data]
  (let [{:keys [selected-project-fields value-mappings keep-union?]} wizard-data
        selected-global-field @(re-frame/subscribe [::global-fields-subs/selected-global-field])
        global-field selected-global-field
        raw-values (or (:values global-field) [])
        global-field-values (if (map? raw-values)
                              (vec (distinct (mapcat val raw-values)))
                              raw-values)
        is-linkedlist? (= (:field_format selected-global-field) "linkedlist")
        all-project-values (global-field-utils/extract-field-values selected-project-fields)]
    [:div.migration-step.migration-value-mapping-step
     ;; Description and options
     [:div.wizard-section.step2-header
      [:p.step-description
       (get-translation "global-fields.migration.step2.description"
                       "Map the existing project field's values to the global field values, or union existing options, or add new values.")]

      [:div.union-option
       [:label.checkbox-label
        [:input.m-checkbox
         {:type :checkbox
          :checked (boolean (or keep-union? is-linkedlist?))
          :disabled is-linkedlist?
          :on-change (fn []
                      (re-frame/dispatch [::global-fields-events/migration-toggle-union]))}]
        [:span (get-translation "global-fields.migration.keep-union"
                               "Keep existing project field values - Union both Global and Project field values")]
        [tooltip/mux-tooltip
         {:position "top"}
         (get-translation "global-fields.migration.union-explain"
                          "Keeps existing project field values and adds them to the global field.")
         (fn [props]
           [:div.info-icon (merge (dissoc props :onMouseEnter :onMouseLeave) {})
            [icons/mux-info-circle]])]]]]

     ;; Value mapping grid
     [value-mapping-grid all-project-values global-field-values value-mappings keep-union?]]))

(defn- migration-confirmation-modal [show-confirmation-modal? wizard-data]
  (let [{:keys [selected-project-fields keep-union?]} wizard-data
        selected-global-field @(re-frame/subscribe [::global-fields-subs/selected-global-field])
        entity-count @(re-frame/subscribe [::global-fields-subs/migration-entity-count])
        ;; Display 10000+ if the count equals 10000 (the limit)
        display-count (if (= entity-count 10000) "10000+" entity-count)
        show-modal-atom (reagent/atom show-confirmation-modal?)]
    [delete-confirmation-modal
     {:show?                    show-modal-atom
      :show-footer?             true
      :show-icon?               false
      :header-class             "centered-title"
      :modal-class              "migration-confirmation-modal"
      :title                    (get-translation "global-fields.migration.confirmation.title" "Migration Confirmation")
      :body                     [:div.migration-confirmation-body.text-center
                                 [:p.confirmation-text
                                  (get-translation "global-fields.migration.confirmation.selected-field"
                                                  "The selected global field - ")
                                  [:strong (:label selected-global-field)]
                                  " ("
                                  (global-field-common/get-field-format-label (:field_format selected-global-field))
                                  ") will replace the project-level fields selected ( Total of "
                                  (count selected-project-fields)
                                  " )."]

                                 [:p.confirmation-text
                                  (get-translation "global-fields.migration.confirmation.will-be-updated"
                                                  "Dashboards, Reports and filters will be updated accordingly using the new global field.")]

                                 [:p.confirmation-text
                                  (format-translation
                                   (get-translation "global-fields.migration.confirmation.entities-affected"
                                                   "Existing entities will be affected and updated with the new values total of %{count} entities are updated")
                                   :count display-count)]]
      :on-delete (fn []
                  (re-frame/dispatch [::global-fields-events/hide-confirmation-modal])
                  (re-frame/dispatch [::global-fields-events/migration-save]))
      :on-cancel (fn []
                  (re-frame/dispatch [::global-fields-events/hide-confirmation-modal]))
      :confirmation-button-text (get-translation "global-fields.migration.confirmation.approve" "Approve")}]))

(defn- migration-wizard-footer [{:keys [current-step selected-project-fields value-mappings keep-union?] :as wizard-data}]
  (let [selected-global-field @(re-frame/subscribe [::global-fields-subs/selected-global-field])
        project-fields-by-project @(re-frame/subscribe [::global-fields-subs/migration-wizard-project-fields])
        ;; Flatten all fields from all projects
        all-fields (mapcat :fields project-fields-by-project)
        project-fields-data (filter #(some #{(:id %)} selected-project-fields) all-fields)
        all-project-values (global-field-utils/extract-field-values project-fields-data)]
    [:div.wizard-footer
     [:div.wizard-footer-buttons
      (case current-step
        1 [:<>
           [buttons/button
            {:text (get-translation "generic.button.continue-to-step-2" "Continue to Step 2")
             :primary? true
             :size "large"
             :disabled? (or (nil? selected-global-field) (empty? selected-project-fields))
             :on-click #(re-frame/dispatch [::global-fields-events/migration-next-step])}]
           [buttons/button {:text (get-translation "generic.button.back" "Back")
                            :tertiary? true
                            :href nil
                            :on-click #(re-frame/dispatch [::global-fields-events/cancel-migration-wizard])}]]
        2 [:<>
           [buttons/button {:text (get-translation "global-fields.migration.continue-to-confirmation" "Continue to Confirmation")
                            :primary? true
                            :size "large"
                            :disabled? (and (not keep-union?)
                                            (some (fn [project-value]
                                                   (let [mapped (get value-mappings project-value)]
                                                     (nil? mapped)))
                                                 all-project-values))
                            :on-click #(re-frame/dispatch [::global-fields-events/show-confirmation-modal])}]
           [buttons/button {:text (get-translation "generic.button.back" "Back")
                            :tertiary? true
                            :href nil
                            :on-click #(re-frame/dispatch [::global-fields-events/migration-previous-step])}]])]]))


(defn- migration-wizard []
  (let [wizard-data @(re-frame/subscribe [::global-fields-subs/migration-wizard-data])
        {:keys [title current-step selected-project-fields show-confirmation-modal?]} wizard-data]
    [:<>
     ;; Confirmation Modal
     (when show-confirmation-modal?
       [migration-confirmation-modal show-confirmation-modal? wizard-data])

     ;; Wizard Container
     [:div.migration-wizard-container
      ;; Header
      [:div.wizard-header
       [:h2.wizard-title title]
       [:h5.wizard-sub-title (get-translation "global-fields.migration.wizard-sub-title" "Combine multiple fields into a single field with intelligent option mapping")]
       [:div.step-indicator
        (if (= current-step 1)
          [:span.step
           (str "Step 1 of 2: " (get-translation "global-fields.migration.step1.title" "Choose Fields to Merge"))]
          [:span.step
           (str "Step 2 of 2: " (get-translation "global-fields.migration.step2.title" "Map Field Values"))]
          )
        ]]

      ;; Body
      [:div.wizard-body
       (case current-step
         1 [migration-fields-selection-step wizard-data]
         2 [migration-value-mapping-step wizard-data]
         nil)]

      ;; Footer
      [migration-wizard-footer wizard-data]]]))

(defn- linked-list-wizard-step-1
  [{:keys [wizard-data filtered-fields can-continue? global-parent-options selected-project-ids]}]
  (let [{:keys [global-field-id global-field-name search-query selected-field-ids
                new-global-name loading?]} wizard-data]
    [:<>
     [:div.wizard-body
      ;; Select Global Parent Field
      [:div.wizard-form-row
       [:label.wizard-form-label (get-translation "global-fields.linked-list.select-parent" "Select Global Parent Field")]
       [:div.wizard-form-content
        [:select.wizard-select
         {:value (or global-field-id "")
          :on-change (fn [e]
                       (let [new-id (js/parseInt (.. e -target -value) 10)
                             field (first (filter #(= (:id %) new-id) global-parent-options))]
                         (when field
                           (re-frame/dispatch [::global-fields-events/linked-list-select-global-field
                                               (:id field) (:label field)]))))}
         (doall
          (for [field global-parent-options]
            ^{:key (:id field)}
            [:option {:value (:id field)} (:label field)]))]]]

      ;; Select Project Linked List Fields
      [:div.wizard-form-row.linked-list-fields-row
       [:label.wizard-form-label (get-translation "global-fields.linked-list.select-fields" "Select Project Linked List Fields")]
       [:div.wizard-form-content
        [:div.linked-list-fields-panel
         [:input.linked-list-search
          {:type "text"
           :placeholder (get-translation "global-fields.linked-list.search-placeholder" "Search Fields by name...")
           :value (or search-query "")
           :on-change (fn [e]
                        (re-frame/dispatch [::global-fields-events/linked-list-update-search
                                            (.. e -target -value)]))}]
         [:p.linked-list-helper-text
          (get-translation "global-fields.linked-list.helper-text" "Select linked fields to import to the selected global field. Only linked lists connected to the same parent are available. Choose one field per project.")]
         [:div.linked-list-field-list
          (cond
            loading?
            [:div.empty-section-grid (get-translation "generic.loading" "Loading...")]

            (empty? filtered-fields)
            [:div.empty-section-grid (get-translation "global-fields.linked-list.no-fields" "No linked list fields found")]

            :else
            (doall
             (for [field filtered-fields]
               (let [is-selected? (contains? selected-field-ids (:id field))
                     other-from-same-project? (and (not is-selected?)
                                                   (contains? selected-project-ids (:project_id field)))]
                   ^{:key (:id field)}
                   [:div.linked-list-field-item
                    {:class (when other-from-same-project? "disabled")
                     :on-click (when-not other-from-same-project?
                                 (fn []
                                   (re-frame/dispatch [::global-fields-events/linked-list-toggle-field
                                                       (:id field) (:project_id field)])))}
                    [:input {:type "checkbox"
                             :checked is-selected?
                             :on-change (fn [])
                             :read-only true}]
                    [:div.linked-list-field-info
                     [:div.linked-list-field-details
                      [:div.linked-list-field-name [:strong (:name field)]]
                      [:span.linked-list-field-type (get-translation "global-fields.linked-list.type-label" "Linked List")]]
                     [:div.linked-list-field-project
                      (:project_name field)
                      (when (seq (:entity_types field))
                        (str " (" (string/join ", " (:entity_types field)) ")"))]]
                    (when other-from-same-project?
                      [:span.linked-list-field-constraint (get-translation "global-fields.linked-list.one-per-project" "One per project")])]))))]]]]

      ;; Name input row
      [:div.wizard-form-row
       [:label.wizard-form-label (get-translation "global-fields.linked-list.name-label" "Name the new Global linked list")]
       [:div.wizard-form-content
        [:input.wizard-text-input
         {:type "text"
          :value (or new-global-name "")
          :placeholder (get-translation "global-fields.linked-list.name-placeholder" "Enter name...")
          :on-change (fn [e]
                       (re-frame/dispatch [::global-fields-events/linked-list-update-name
                                           (.. e -target -value)]))}]]]]

     ;; Footer
     [:div.wizard-footer
      [:div.wizard-footer-buttons
       [buttons/button {:text (get-translation "global-fields.linked-list.continue-step2" "Continue to Step 2 - Confirmation")
                        :primary? true
                        :size "large"
                        :disabled? (not can-continue?)
                        :on-click #(re-frame/dispatch [::global-fields-events/linked-list-next-step])}]
       [buttons/button {:text (get-translation "generic.button.cancel" "Cancel")
                        :tertiary? true
                        :on-click #(re-frame/dispatch [::global-fields-events/cancel-linked-list-wizard])}]]]]))

(defn- linked-list-wizard-step-2
  [{:keys [wizard-data union-values-count import-in-progress?]}]
  (let [{:keys [global-field-name new-global-name]} wizard-data]
    [:<>
     [:div.wizard-body
      [:div.linked-list-step2
       [:p.step2-description
        (get-translation "global-fields.linked-list.step2-description" "Map the existing project field's values to the global field values. Select from existing options or add new values.")]

       [:label.checkbox-label.step2-checkbox
        [:input.m-checkbox
         {:type :checkbox
          :checked true
          :disabled true}]
        [:span (get-translation "global-fields.linked-list.keep-union" "Keep existing project field values - Union all Project field values to one list and use existing linkage to parent values")]
        [tooltip/mux-tooltip
         {:position "top"}
         (get-translation "global-fields.linked-list.keep-union-tooltip" "Keeps existing project field values and adds them to the global field.")
         (fn [props]
           [:div.info-icon (dissoc props :onMouseEnter :onMouseLeave)
            [icons/mux-info-circle]])]]

       [:div.step2-summary-box
        [:p (get-translation "global-fields.linked-list.mapping-description" "This mapping provides a single option: combining all project-level field values into one unified set, with duplicates removed. Parent value associations will remain unchanged.")]
        [:p (get-translation "global-fields.linked-list.confirm-action" "Confirming this action will:")]
        [:ul
         [:li (format-translation
               (get-translation "global-fields.linked-list.confirm-create" "Create a global linked list named \"%{name}\"")
               :name new-global-name)]
         [:li (format-translation
               (get-translation "global-fields.linked-list.confirm-include" "Include %{count} values")
               :count union-values-count)]
         [:li (format-translation
               (get-translation "global-fields.linked-list.confirm-link" "Link the values to \"%{field}\", preserving the existing value associations")
               :field global-field-name)]]]]]

     [:div.wizard-footer
      [:div.wizard-footer-buttons
       [buttons/button {:text (if import-in-progress?
                                    (get-translation "global-fields.linked-list.importing" "Importing...")
                                    (get-translation "global-fields.linked-list.confirm-apply" "Confirm and Apply"))
                        :primary? true
                        :size "large"
                        :disabled? import-in-progress?
                        :on-click #(re-frame/dispatch [::global-fields-events/linked-list-import])}]
       [buttons/button {:text (get-translation "generic.button.back" "Back")
                        :tertiary? true
                        :disabled? import-in-progress?
                        :on-click #(re-frame/dispatch [::global-fields-events/linked-list-previous-step])}]]]]))

(defn- linked-list-wizard []
  (let [wizard-data @(re-frame/subscribe [::global-fields-subs/linked-list-wizard-data])
        {:keys [current-step]} wizard-data
        filtered-fields @(re-frame/subscribe [::global-fields-subs/linked-list-wizard-filtered-fields])
        can-continue? @(re-frame/subscribe [::global-fields-subs/linked-list-wizard-can-continue?])
        global-parent-options @(re-frame/subscribe [::global-fields-subs/linked-list-global-parent-options])
        selected-project-ids @(re-frame/subscribe [::global-fields-subs/linked-list-wizard-selected-project-ids])
        union-values-count @(re-frame/subscribe [::global-fields-subs/linked-list-wizard-union-values-count])
        import-in-progress? @(re-frame/subscribe [::global-fields-subs/linked-list-import-in-progress?])]
    [:div.migration-wizard-container
     ;; Header
     [:div.wizard-header
      [:h2.wizard-title (get-translation "global-fields.linked-list.wizard-title" "Import Linked List Fields Wizard")]
      [:h5.wizard-sub-title (get-translation "global-fields.linked-list.wizard-subtitle" "Import linked lists from projects into Global list Field")]
      [:div.step-indicator
       [:span.step
        (if (= current-step 1)
          (get-translation "global-fields.linked-list.step1-title" "Step 1 of 2: Choose Linked Fields to Import")
          (get-translation "global-fields.linked-list.step2-title" "Step 2 of 2: Map Field Values"))]]]

     ;; Body + Footer by step
     (case current-step
       1 [linked-list-wizard-step-1
          {:wizard-data wizard-data
           :filtered-fields filtered-fields
           :can-continue? can-continue?
           :global-parent-options global-parent-options
           :selected-project-ids selected-project-ids}]
       2 [linked-list-wizard-step-2
          {:wizard-data wizard-data
           :union-values-count union-values-count
           :import-in-progress? import-in-progress?}]
       nil)]))

(defn- migration-stage-label [stage]
  (case stage
    "validating" (get-translation "global-fields.migration.status-banner.stage.validating" "Validating fields")
    "migrating_values" (get-translation "global-fields.migration.status-banner.stage.migrating-values" "Migrating entity values")
    "migrating_settings" (get-translation "global-fields.migration.status-banner.stage.migrating-settings" "Migrating settings & reports")
    "finalizing" (get-translation "global-fields.migration.status-banner.stage.finalizing" "Finalizing migration")
    "completed" (get-translation "global-fields.migration.status-banner.stage.completed" "Completed")
    (get-translation "global-fields.migration.status-banner.stage.starting" "Starting migration")))

(defn- migration-status-banner []
  (let [{:keys [locked? completed? field-name stage percentage refreshing? last-refreshed-at]}
        @(re-frame/subscribe [::global-fields-subs/migration-status])]
    [async-status-banner/async-status-banner
     {:locked? locked?
      :completed? completed?
      :stage-label (migration-stage-label (or stage "starting"))
      :percentage percentage
      :refreshing? refreshing?
      :last-refreshed-label (when last-refreshed-at
                              (format-translation
                               (get-translation "global-fields.migration.status-banner.last-updated" "Updated at %{time}")
                               :time (global-field-utils/format-last-refreshed last-refreshed-at)))
      :on-refresh #(re-frame/dispatch [::global-fields-events/refresh-status :migration])
      :on-dismiss #(re-frame/dispatch [::global-fields-events/dismiss-migration-status])
      :title (get-translation "global-fields.migration.status-banner.title" "Migration in progress")
      :completed-title (get-translation "global-fields.migration.status-banner.completed-title" "Migration Completed")
      :message (format-translation
                (get-translation "global-fields.migration.status-banner.message"
                                 "A migration is currently in progress for the field \"%{field_name}\". Please click Refresh to see the updated status.")
                :field_name (or field-name ""))
      :completed-message (format-translation
                          (get-translation "global-fields.migration.status-banner.completed-message"
                                           "A migration for the field \"%{field_name}\" was completed.")
                          :field_name (or field-name ""))
      :refresh-label (get-translation "global-fields.migration.status-banner.refresh" "Refresh")
      :dismiss-label (get-translation "global-fields.migration.status-banner.dismiss" "Dismiss")}]))


(defn main-panel []
  (let [grid-state (reagent/atom {:module "global-fields"})
        show-wizard? @(re-frame/subscribe [::global-fields-subs/show-migration-wizard?])
        show-linked-list-wizard? @(re-frame/subscribe [::global-fields-subs/show-linked-list-wizard?])]
    (dom/update-page-title (get-translation "global-fields.page-title" "Account Settings - Global Fields"))
    [:div.global-fields-page
     [delete-global-field-alert]
     (cond
       show-wizard? [migration-wizard]
       show-linked-list-wizard? [linked-list-wizard]
       :else [:<>
              [migration-status-banner]
              [:legend (get-translation "navigation.account-settings-panel.global-fields" "Global Fields")]
              [global-fields-grid grid-state]])]))

(defn- sh-form-header [{:keys [edit?]}]
  [:div.view-header (if edit?
                      (get-translation "global-fields.edit-form.title" "Update Global Field")
                      (get-translation "global-fields.create-form.title" "Create Global Field"))])

(defn- sh-form-footer [{:keys [edit?]}]
  (let [current-account @(re-frame/subscribe [::subs/current-account])
        form-data  @(re-frame/subscribe [::global-fields-subs/global-fields-form-data])
        loading? @(re-frame/subscribe [:global-fields-settings/form-loading?])]
    [:div.view-footer
     [buttons/button {:text (get-translation "generic.button.save" "Save")
                      :primary? true
                      :disabled? (or (save-button-disabled? form-data) loading?)
                      :on-click (fn []
                                  (when-not edit? (mixpanel/track
                                                   "Create_Global_Field"
                                                   {"Type" (get-in form-data [:global-field-format :value])}))
                                  (save-button-on-click {:edit? edit?
                                                         :is-enforced? (get-in form-data [:global-field-select-projects :value])}))}]
     [buttons/button {:text (get-translation "global-fields.form-footer.back-to-list" "Back to List")
                      :tertiary? true
                      :href (broutes/get-url-view "account/accounts#global_fields" {:account_id (:id current-account)})}]]))

(defn delete-modal-message [value-used? value]
  [:<>
   (if value-used?
     [:<>
      [:p (get-translation "global-field.delete-possible-value.modal-body-note" "Note: The value you selected is used in multiple projects' entities. Deleting it will remove it from all of them, leaving empty fields. Any linked values will also be deleted.")]
      [:p (get-translation "global-field.delete-possible-value.modal-body-proceed" "Do you want to proceed?")]]
     [:p (get-translation "global-field.delete-possible-value.modal-body-confirm" "Are you sure you want to delete this value?")])
    [:p (format-translation
                   (get-translation "global-field.delete-possible-value.modal-body-value"
                                    (str "Value to delete: " value))
          :value value)]])

(defn- check-possible-value-deletion-modal []
  (let [show? (re-frame/subscribe [::global-fields-subs/global-fields-show-modal])
        {:keys [title value-used? value parent-item]} @(re-frame/subscribe [::global-fields-subs/global-fields-modal-data])]
    [delete-confirmation-modal {:show? show?
                                :show-footer? true
                                :title title
                                :confirmation-button-text (get-translation "generic.button.delete-value" "Delete Value")
                                :body (delete-modal-message value-used? value)
                                :on-delete (fn [] (re-frame/dispatch [::global-fields-events/delete-possible-value value parent-item]))
                                :on-cancel (fn [] (re-frame/dispatch [::global-fields-events/global-fields-hide-modal :modal-data]))}]))

(defn- check-field-relationship-modal [{:keys [edit?]}]
  (let [show? (re-frame/subscribe [::global-fields-subs/global-fields-show-linkage-modal])
        {:keys [title message]} @(re-frame/subscribe [::global-fields-subs/global-fields-linkage-modal-data])]
    [delete-confirmation-modal {:show? show?
                                :show-footer? true
                                :title title
                                :confirmation-button-text (get-translation "generic.button.confirm" "Confirm")
                                :body [:div message]
                                :on-delete (fn [] (re-frame/dispatch [::global-fields-events/save-global-field {:edit? edit?
                                                                                                                 :linkage-confirmed "true"}])
                                             (re-frame/dispatch [::global-fields-events/global-fields-hide-modal :linkage-modal-data]))
                                :on-cancel (fn []
                                             (re-frame/dispatch [::global-fields-events/global-fields-hide-modal :linkage-modal-data])
                                             (re-frame/dispatch [::global-fields-events/clear-form-loading]))}]))

(defn- rename-value-modal []
  (let [{:keys [show? old-value new-value count error]}
        @(re-frame/subscribe [::global-fields-subs/rename-modal-data])
        saving? @(re-frame/subscribe [::global-fields-subs/rename-saving?])
        on-cancel #(re-frame/dispatch [::global-fields-events/close-rename-modal])
        disabled? (or saving? (string/blank? new-value) (= new-value old-value))
        submit (fn [] (re-frame/dispatch [::global-fields-events/submit-rename-value]))]
    [modal/modal-with-notifications
     {:class "global-field-rename-value-modal"
      :is-open? (boolean show?)
      :on-request-close on-cancel
      :close-button? true
      :centered? true}
     ;; header
     [:span (get-translation "global-field.rename-value.title" "Rename Value")]
     ;; body
     [:div.rename-value-modal-body
      [:div.g2-field-container
       [:label.m-label (get-translation "global-field.rename-value.current" "Current value")]
       [:div.current-value old-value]]
      [:div.g2-field-container
       [:label.m-label (get-translation "global-field.rename-value.new" "New value")]
       [:input.search-input {:value (or new-value "")
                             :autoFocus true
                             :disabled saving?
                             :on-change #(re-frame/dispatch [::global-fields-events/set-rename-new-value (dom/event-value %)])
                             :on-key-down (fn [e] (when (and (= "Enter" (.-key e)) (not disabled?)) (submit)))}]]
      (when (some? count)
        [:p.affected-count
         (format-translation
          (get-translation "global-field.rename-value.affected"
                           "This will update %{count} entities across the account.")
          :count count)])
      ;; actions
      [:div.rename-value-modal-footer.add-cancel-component
       [buttons/button {:size "large" :on-click on-cancel
                        :text (get-translation "generic.button.cancel" "Cancel")}]
       [buttons/button {:primary? true
                        :size "large"
                        :disabled? disabled?
                        :icon (when saving? [spinners/inline-spinner-border])
                        :on-click submit
                        :text (get-translation "generic.button.rename" "Rename")}]]]
     ;; notifications
     (when error
       [(notifications/toast-element error {:type "error"
                                            :id "rename-value-error"
                                            :class "in-modal-msg-error"})])]))

(defn global-field-form-page [{:keys [edit?]}]
  [:div.global-fields-page.global-field-create-container
   [check-field-relationship-modal {:edit? edit?}]
   [check-possible-value-deletion-modal]
   [rename-value-modal]
   [sh-form-header {:edit? edit?}]
   [:div.global-field-forms-container [global-field-form/global-field-form {:edit? edit?}]]
   [sh-form-footer {:edit? edit?}]])
